import script from "./PrestacaoContasAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./PrestacaoContasAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./PrestacaoContasAdministrar.vue?vue&type=style&index=0&id=d5755322&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5755322"]])

export default __exports__